export default __webpack_public_path__ + "static/media/boot.e075d29d.svg";